import React from "react";
import SocialLinks from "./SocialLinks";

function Footer() {
    return (
        // <div className='footerImage' style={{backgroundImage: "url(./assets/images/bgnav.jpg)",backgroundPosition: "contain" , backgroundSize: "cover", height: '140px',   boxShadow: "-2px -13px 15px 6px rgba(0,0,0,0.29),-2px 30px 15px 6px rgba(0,0,0,0.29)"}} >Footer</div>
        <>
            <div className="line"></div>

            <div className="footer">
                <a href="#nav-container">

                    <span className="BetikureFooter">Betikure Parc Lodge </span>{" "}
                </a>

   
          <span className="BetikureAdress">
            La Taraudière, Boite 352, Bourail 98870, Nouvelle-Calédonie - 📞 46.23.60
          </span>

                <SocialLinks />
            </div>
        </>
    );
}

export default Footer;
